
export const getImage = state => state.events.image;